const {
    checkValueExistence,
    ArrayToArrayMatcher
} = require('../utils')
const ListOperators = {
    is_any_of: {
        id: 'is_any_of',
        matcher: (value, matchValue) => {
            return ArrayToArrayMatcher(value, matchValue);
        }
    },
    is_none_of: {
        id: 'is_none_of',
        matcher: (value, matchValue) => {
            if(!value) return true;
            return !(ArrayToArrayMatcher(value, matchValue));
        }
    },
    is_known_for_list: {
        id: 'is_known_for_list',
        matcher: (value, matchValue) => {
            return checkValueExistence(value);
        }
    },
    is_unknown_for_list: {
        id: 'is_unknown_for_list',
        matcher: (value, matchValue) => {
            return !(checkValueExistence(value));
        }
    }
}
module.exports.ListOperators = ListOperators;